import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnDestroy, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';

export interface TableProperties {
  borderColor: string;
  borderWidth: number;
  borderStyle: 'solid' | 'dashed' | 'dotted' | 'double' | 'none';
  backgroundColor: string;
  cellPadding: number;
  cellSpacing: number;
  width: string; // e.g., "100%" or "500px"
  widthType: 'percent' | 'pixels';
  widthValue: number;
  alignment: 'left' | 'center' | 'right';
  marginLeft: number;
  marginRight: number;
}

@Component({
  selector: 'app-table-properties-dialog',
  templateUrl: './table-properties-dialog.component.html',
  styleUrls: ['./table-properties-dialog.component.scss']
})
export class TablePropertiesDialogComponent implements OnDestroy {

  sanitizedUrl: string = '';


  url = '';

  properties: TableProperties;

  presetColors = [
    '#000000', '#424242', '#636363', '#9C9C94', '#CEC6CE', '#EFEFEF', '#F7F7F7', '#FFFFFF',
    '#FF0000', '#FF9C00', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#9C00FF', '#FF00FF',
    '#F7C6CE', '#FFE7CE', '#FFEFC6', '#D6EFD6', '#CEDEE7', '#CEE7F7', '#D6D6E7', '#E7D6DE',
    '#E79C9C', '#FFC69C', '#FFE79C', '#B5D6A5', '#A5C6CE', '#9CC6EF', '#B5A5D6', '#D6A5BD',
    '#E76363', '#F7AD6B', '#FFD663', '#94BD7B', '#73A5AD', '#6BADDE', '#8C7BC6', '#C67BA5',
    '#CE0000', '#E79439', '#EFC631', '#6BA54A', '#4A7B8C', '#3984C6', '#634AA5', '#A54A7B',
    '#9C0000', '#B56308', '#BD9400', '#397B21', '#104A5A', '#085294', '#311873', '#731842',
    '#630000', '#7B3900', '#846300', '#295218', '#083139', '#003163', '#21104A', '#4A1031'
  ];

  borderStyles = [
    { value: 'solid', label: 'Solid' },
    { value: 'dashed', label: 'Dashed' },
    { value: 'dotted', label: 'Dotted' },
    { value: 'double', label: 'Double' },
    { value: 'none', label: 'None' }
  ];

  constructor(
    @Optional() public dialogRef: MatDialogRef<TablePropertiesDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TableProperties, private router: Router
  ) {
    this.properties = { ...data };
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }

  onWidthTypeChange() {
    // Convert between % and px
    if (this.properties.widthType === 'percent' && this.properties.widthValue > 100) {
      this.properties.widthValue = 100;
    }
  }

  save() {
    // Build the width string
    this.properties.width = this.properties.widthType === 'percent'
      ? `${this.properties.widthValue}%`
      : `${this.properties.widthValue}px`;
    
    this.dialogRef.close(this.properties);
  }

  cancel() {
    this.dialogRef.close();
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
